"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getValuePair = function (value, start, end) {
    return parseInt(value.substring(start, end), 16);
};
var HexToRgb = function (hex) {
    var rgbValues = hex.replace('#', '');
    var red = getValuePair(rgbValues, 0, 2);
    var green = getValuePair(rgbValues, 2, 4);
    var blue = getValuePair(rgbValues, 4, 6);
    var rgbValue = red + ", " + green + ", " + blue;
    return rgbValue;
};
exports.default = HexToRgb;
//# sourceMappingURL=hexToRGB.js.map